'use client'

import { SpacePage } from '@/screens/SpaceIport'

const SpacePageContent = () => {
	return <SpacePage />
}

export function SpaceClient() {
	return <SpacePageContent />
}
